import React, { useState, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const defaultTimeRange = {
  start: null as null,
  end: null as null,
};

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
  textField: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    width: 75,
  },
}));

interface TimePickerContainerProps {
  selectHours: (start: any, end: any, index: number) => void;
  indexTimer: number;
  timeRange?: [any, any];
}

export default function TimePickerContainer({ selectHours, indexTimer, timeRange }: TimePickerContainerProps) {
  const { classes } = useStyles();

  const [selectedStartDate, setSelectedStartDate] = React.useState<any>(
    timeRange !== undefined ? timeRange[0] : defaultTimeRange.start,
  );
  const [selectedEndDate, setSelectedEndDate] = React.useState<any>(
    timeRange !== undefined ? timeRange[1] : defaultTimeRange.end,
  );

  const handleStartDateChange = (date: any) => {
    setSelectedStartDate(date);
  };
  const handleEndDateChange = (date: any) => {
    setSelectedEndDate(date);
  };

  useEffect(() => {
    selectHours(selectedStartDate, selectedEndDate, indexTimer);
  }, [selectedStartDate, selectedEndDate]);

  return (
    <div className={classes.container}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label="à partir de"
        value={selectedStartDate}
        onChange={handleStartDateChange}
        ampm={false}
        minutesStep={5}
        renderInput={(params) => <TextField {...params} />}
      />
      <TimePicker
        label="jusqu'à"
        value={selectedEndDate}
        onChange={handleEndDateChange}
        ampm={false}
        minutesStep={5}
        renderInput={(params) => <TextField {...params} />}
      />
      </LocalizationProvider>
    </div>
  );
}
